import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="2" fill="none" viewBox="0 0 14 2" className={className}>
    <path fill="#000" d="M0 2V0h14v2H0z"></path>
  </svg>
);

export default Icon;
